const SLOT_START_HOUR = 8;
const SLOT_END_HOUR = 16;
const SLOT_STEP_MINUTES = 30;
const SLOT_CONFLICT_BUFFER_MS = 59 * 60 * 1000;

export type WellbeingGridCell = { value: string; label: string; disabled: boolean };
export type WellbeingGridRow = { time: string; cells: WellbeingGridCell[] };

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

export function buildWellbeingWeekGrid(days: Date[], bookedSlotGroups: string[][], now = Date.now()): WellbeingGridRow[] {
  const bookedTimeGroups = bookedSlotGroups.map((slots) => slots.map((iso) => new Date(iso).getTime()));
  const rows: WellbeingGridRow[] = [];
  for (let hour = SLOT_START_HOUR; hour < SLOT_END_HOUR; hour += 1) {
    for (let minute = 0; minute < 60; minute += SLOT_STEP_MINUTES) {
      const cells: WellbeingGridCell[] = days.map((day) => {
        const slotDate = new Date(day.getFullYear(), day.getMonth(), day.getDate(), hour, minute);
        const past = slotDate.getTime() <= now;
        const busy = bookedTimeGroups.length > 0 && bookedTimeGroups.every((times) =>
          times.some((time) => Math.abs(time - slotDate.getTime()) < SLOT_CONFLICT_BUFFER_MS),
        );
        const dateInput = `${slotDate.getFullYear()}-${pad(slotDate.getMonth() + 1)}-${pad(slotDate.getDate())}`;
        return { value: `${dateInput}T${pad(hour)}:${pad(minute)}`, label: `${pad(hour)}:${pad(minute)}`, disabled: past || busy };
      });
      rows.push({ time: `${pad(hour)}:${pad(minute)}`, cells });
    }
  }
  return rows;
}
